<template>
  <main>
    <v-container fluid grid-list-lg mb-3>
      <v-layout row wrap>
        <v-flex xs12 sm5 offset-sm1>
          <UserInfo
            class="user-info-container"
            v-if="$route.path === '/profile'"
          />
          <div v-else></div>
        </v-flex>
        <v-flex xs12 sm5 offset-sm1> </v-flex>
      </v-layout>
    </v-container>

    <div class="mobileMenu">
      <v-menu
        offset-y
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn class="menuButton" dark v-on="on">
            {{ tabName }} <v-icon>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in profileOptions"
            :key="index"
            @click="switchTab(item)"
          >
            <div>
              <v-list-tile-title v-if="item.show">{{
                item.title
              }}</v-list-tile-title>
            </div>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>

    <v-tabs v-model="tab" show-arrows centered >

      <v-tabs-slider ></v-tabs-slider >
      

      <v-tab href="#tab-1" class="tabMenu">Profile</v-tab>
      <v-tab href="#tab-2" class="tabMenu">Email</v-tab>
      <v-tab href="#tab-3" class="tabMenu" v-if="showPassword === true">Password</v-tab>
      <v-tab href="#tab-4" class="tabMenu" v-if="showTicketingLink === true"
        >Link Client Reference</v-tab
      >
      <v-tab href="#tab-5" class="tabMenu">Preferences</v-tab>
      <!--<v-tab href="#tab-5" >Membership &amp; Loyalty</v-tab>-->

      <v-tab-item :value="'tab-1'" :key="1">
        <div v-if="configValues.accountProfilePicturesAllowed === true">
          <UserProfileImage />
        </div>
        <UserProfileFull />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" :value="'tab-2'" :key="2">
        <UserProfileChangeEmail />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" :value="'tab-3'" :key="3">
        <UserProfilePassword />
      </v-tab-item>

      <v-tab-item v-if="showTicketingLink === true" :value="'tab-4'" :key="4">
        <UserProfileTicketmasterLink />
      </v-tab-item>

      <v-tab-item :value="'tab-5'" :key="5">
        <UserProfileContactPrefs />
      </v-tab-item>

      <!--<v-tab-item :value="'tab-5'" :key="5">
        <UserProfileMembership />
        <UserProfileClientRefNo />
      </v-tab-item>-->
    </v-tabs>

    <FooterShout :type="'help'" />
  </main>
</template>

<script>
import UserProfileFull from "@/components/UserProfileFull";
import UserProfilePassword from "@/components/UserProfilePassword";
import UserProfileChangeEmail from "@/components/UserProfileChangeEmail";
// import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
import UserProfileImage from "@/components/UserProfileImage";
//import UserProfileSeatgeekLink from '@/components/UserProfileSeatgeekLink'
import UserProfileTicketmasterLink from "@/components/UserProfileTicketmasterLink";
import UserProfileContactPrefs from "@/components/UserProfileContactPrefs";
// import UserProfileMembership from '@/components/UserProfileMembership'
import FooterShout from "@/components/FooterShout";
import UserInfo from "@/components/UserInfo";

export default {
  components: {
    UserProfileFull,
    UserInfo,
    UserProfileChangeEmail,
    UserProfilePassword,
    // UserProfileClientRefNo,
    UserProfileImage,
    //UserProfileSeatgeekLink,
    UserProfileTicketmasterLink,
    UserProfileContactPrefs,
    // UserProfileMembership,
    FooterShout,
  },
  data() {
    return {
      showPassword: false,
      showMembership: false,
      showTicketingLink: false,
      profileOptions: [],
      tab: "tab-1",
      tabName: "Profile",
    };
  },
  mounted() {
    console.log("User Profile component loaded");
    this.profileOptions = this.configValues.profileOptions.filter(
      (item) => item.show === true
    );
    console.log("PROFILE OPTIONS", this.profileOptions);
    if (this.$getAuthenticatedUser() == null) {
      console.log("User is not logged in");
      this.$router.push("/");
    } else {
      if (localStorage.loginFlow == "TicketMasterNoClientRef") {
        this.tab = "tab-4";
      }
      // check to see if the user was created with traditional registration (and not Facebook or Google)
      this.$getCurrentUserAttributes().subscribe((userData) => {
        if (userData.email_verified) {
          console.log("user allowed to change password");
          this.showPassword = true; //if they did register with their email, then let them change password
        }
        // Allow ticketing link tab to be seen if user is from approved organisation
        if (
          this.configValues.seatGeekAccountLinkingEnabled === true &&
          (userData.email.includes("@urbanzoo.io") ||
            userData.email.includes("@" + this.configValues.clubRootDomain) ||
            userData.email.includes("@seatgeek.com"))
        ) {
          this.showTicketingLink = true;
        }
      });
    }
    console.log(this.$root.$data.referrer);
  },
  methods: {
    switchTab(item) {
      this.tab = item.tab;
      this.tabName = item.title;
    },
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-tabs__bar .v-tabs__div {
  color: $primary-club-light;
}

.header {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0;
  margin: 0 0 35px;
}
.mini-nav {
  width: 250px;
}
.mini-nav li {
  list-style: none;
}

.menuButton {
  width: 90%;
  margin-left: 20px;
  color: white;
  background-color: rgb(246, 246, 246) !important;
  color: #008a4d;
  border-radius: 8px;
  font-weight: bold;
}

@media (max-width: 500px) {
  .tabMenu {
    display: none;
  }
  .mobileMenu {
    display: block;
  }
}
@media (min-width: 500px) {
  .tabMenu {
    display: block;
  }
  .mobileMenu {
    display: none !important;
  }
}
</style>
